import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Building2, BadgeCheck, ShieldCheck, Wallet } from "lucide-react";
import { RecruitmentFallback } from "@/components/RecruitmentFallback";
import { AdaptiveMediaFrame } from "@/components/AdaptiveMediaFrame";

export function RecruitmentCard({ r }) {
  const loc = r.is_remote ? "Remote" : [r.city, r.province].filter(Boolean).join(", ");
  const orgName = r.organization?.name || r.recruiter?.name;
  return (
    <Link to={`/recruitment/${r.id}`} data-testid={`recruitment-card-${r.id}`}
      className="group block bg-white rounded-2xl border border-slate-200 overflow-hidden hover:shadow-md hover:-translate-y-0.5 transition-all duration-200">
      {/* PROTECTED MEDIA — no platform text/badges over recruitment artwork */}
      <AdaptiveMediaFrame
        src={r.cover_image}
        alt={r.title}
        policy="preservation"
        tone="light"
        context="card"
        naturalCard
        rounded=""
        data-testid={`recruitment-card-media-${r.id}`}
        fallback={<RecruitmentFallback title={r.title} org={orgName} typeLabel={r.employment_type_label} variant="card" />}
      />
      <div className="p-4">
        <div className="flex flex-wrap items-center gap-1.5 mb-1.5">
          <span className="inline-block text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-full bg-[#C79A3B]/12 text-[#9a6f18]">{r.employment_type_label}</span>
          {r.is_remote && <span className="inline-block text-[10px] font-semibold uppercase tracking-wide px-2 py-0.5 rounded-full bg-[#0F2C59]/8 text-[#0F2C59]">Remote</span>}
        </div>
        <h3 className="font-display font-bold text-slate-900 line-clamp-2 leading-snug group-hover:text-[#0F2C59] transition-colors">{r.title}</h3>
        {r.role_category && <p className="text-[13px] text-slate-500 mt-0.5 truncate">{r.role_category}</p>}
        <div className="mt-2.5 space-y-1 text-[13px] text-slate-500">
          {r.organization?.name && (
            <div className="flex items-center gap-1.5 min-w-0">
              <Building2 className="h-3.5 w-3.5 shrink-0 text-slate-400" />
              <span className="truncate">{r.organization.name}</span>
              {r.organization.is_verified && <BadgeCheck className="h-3.5 w-3.5 text-emerald-600 shrink-0" />}
              {r.organization.is_partner && <ShieldCheck className="h-3.5 w-3.5 text-[#C79A3B] shrink-0" />}
            </div>
          )}
          {loc && <div className="flex items-center gap-1.5 min-w-0"><MapPin className="h-3.5 w-3.5 shrink-0 text-slate-400" /><span className="truncate">{loc}</span></div>}
          {r.compensation_text && <div className="flex items-center gap-1.5 min-w-0 font-medium text-slate-700"><Wallet className="h-3.5 w-3.5 shrink-0 text-slate-400" /><span className="truncate">{r.compensation_text}</span></div>}
        </div>
        <div className="mt-3 pt-3 border-t border-slate-100 flex items-center gap-2">
          {r.recruiter?.avatar && <img src={r.recruiter.avatar} alt="" className="h-6 w-6 rounded-full object-cover" />}
          <span className="text-xs text-slate-500 truncate">{r.recruiter?.name}</span>
        </div>
      </div>
    </Link>
  );
}

export default RecruitmentCard;
